import React from "react";
import { useDispatch } from "react-redux";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import { getLocalizedString } from "@icarius-localization/strings";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import { sendMailEvaluationProcessDefinitionAction } from "../../actions";
import Loader from "@icarius-common/loader";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const MailDialog = (props) => {

    const {
        open,
        data,
        isLoading,
        handleClose,
    } = props;

    const dispatch = useDispatch();

    const create = (dataToSend) => {
        dispatch(sendMailEvaluationProcessDefinitionAction(dataToSend))
            .then((res) => res?.status === 200 && handleClose());
    }

    const openValidationError = () => {
        dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
    }

    const {
        formData,
        setFormValue,
        submit,
    } = useHandleForm(data, create, openValidationError);

    return (
        <Dialog
            open={open}
            TransitionComponent={DialogTransition}
            PaperComponent={PaperDraggable}
            maxWidth={"md"}
            fullWidth={true}
        >
            <div className={"dialog-container"}>
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {data.evaluationStatus === 'K' ? getLocalizedString("f") : getLocalizedString("performanceEvaluationProcessStart")}
                    <DialogTitleDivider />
                </DialogTitle>
                <DialogContent>
                    <Loader open={isLoading} />
                    <Grid container item xs={12}>
                        <TextFieldMultiline
                            fullWidth
                            rows={10}
                            margin={"none"}
                            value={formData.message}
                            inputProps={{ spellCheck: 'false' }}
                            onChange={(e) => setFormValue(e.target.value, "message")}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <ButtonDialogAction onClick={handleClose} text={getLocalizedString("cancel")} />
                    <ButtonDialogAction onClick={submit} isAccept text={getLocalizedString("accept")} />
                </DialogActions>
            </div>
        </Dialog>
    );
}

export default MailDialog;